import { useMemo, useState } from 'react';
import Reveal from '@/components/base/Reveal';
import SectionHeading from '@/pages/home/components/SectionHeading';
import { liveHosts, liveTags } from '@/mocks/home';

export default function LiveNow() {
  const [activeTag, setActiveTag] = useState('全部');

  const filtered = useMemo(
    () => (activeTag === '全部' ? liveHosts : liveHosts.filter((host) => host.tag === activeTag)),
    [activeTag],
  );

  return (
    <section id="live" className="bg-background-50 py-14 md:py-20">
      <div className="mx-auto w-full max-w-[1280px] px-4 md:px-6">
        <SectionHeading
          kicker="正在开播"
          title="此刻热度最高的直播间"
          desc="实时同步主播开播状态与在线人数，点开就能进直播间互动。"
          action={
            <a
              href="#ranking"
              className="inline-flex items-center gap-1.5 whitespace-nowrap rounded-md border border-background-300 px-4 py-2.5 text-sm font-medium text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-600"
            >
              查看完整榜单
              <i className="ri-arrow-right-line" />
            </a>
          }
        />

        <div className="mt-6 flex flex-wrap gap-2">
          {liveTags.map((tag) => (
            <button
              key={tag}
              type="button"
              onClick={() => setActiveTag(tag)}
              className={`cursor-pointer whitespace-nowrap rounded-full px-4 py-2 text-sm font-medium transition-colors ${
                activeTag === tag
                  ? 'bg-primary-500 text-background-50'
                  : 'bg-background-100 text-foreground-700 hover:bg-background-200'
              }`}
            >
              {tag}
            </button>
          ))}
        </div>

        <div className="mt-8 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {filtered.map((host, index) => (
            <Reveal key={host.id} delay={(index % 4) * 70}>
              <article className="group flex h-full cursor-pointer flex-col overflow-hidden rounded-xl border border-background-200 bg-background-50 transition-all duration-300 hover:-translate-y-1 hover:border-primary-300">
                <div className="relative aspect-[8/5] w-full overflow-hidden">
                  <img
                    src={host.cover}
                    alt={`${host.name} 的直播封面`}
                    title={`${host.name} ${host.tag} 直播`}
                    className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                  />
                  <span className="absolute left-3 top-3 flex items-center gap-1.5 rounded-full bg-primary-500 px-2.5 py-1 text-[11px] font-medium text-background-50">
                    <span className="h-1.5 w-1.5 rounded-full bg-background-50" />
                    LIVE
                  </span>
                  <span className="absolute bottom-3 right-3 flex items-center gap-1 rounded-full bg-foreground-950/65 px-2.5 py-1 text-[11px] text-background-50 backdrop-blur-sm">
                    <i className="ri-eye-line" />
                    {host.viewers}
                  </span>
                </div>
                <div className="flex flex-1 flex-col p-4">
                  <h3 className="line-clamp-1 font-heading text-base font-bold text-foreground-950">{host.title}</h3>
                  <p className="mt-2 line-clamp-2 flex-1 text-xs leading-relaxed text-foreground-600">{host.summary}</p>
                  <div className="mt-4 flex items-center justify-between border-t border-background-200 pt-3">
                    <span className="flex items-center gap-2 text-sm font-medium text-foreground-800">
                      <span className="flex h-6 w-6 items-center justify-center rounded-full bg-secondary-100 text-[11px] font-bold text-secondary-800">
                        {host.name.slice(0, 1)}
                      </span>
                      {host.name}
                    </span>
                    <span className="rounded-full bg-accent-100 px-2.5 py-1 text-[11px] font-medium text-accent-800">
                      {host.tag}
                    </span>
                  </div>
                </div>
              </article>
            </Reveal>
          ))}
        </div>

        {filtered.length === 0 && (
          <p className="mt-10 rounded-xl border border-dashed border-background-300 bg-background-100 py-12 text-center text-sm text-foreground-500">
            该分类暂时没有正在开播的主播，换个标签看看吧。
          </p>
        )}
      </div>
    </section>
  );
}